<template>
<div>
    <header>
    	<a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Aktivität</h1>
    </header>
    <timeline :activities="activities" :big="true" />
</div>
</template>	

<script>
import timeline from 'components/timeline.vue'
import base from 'base.vue'

export default {
	mixins: [ base ],
	components: { timeline },
	data () {
		return {
			activities: [ ]
		}
	},
	methods: {
		fetchData () {
			return this.$api.get(`timeline/${this.$route.params.id}`)
			.then(response => {
				this.activities = [ response.data ]
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// activity.vue?8dc0bd32